import { Link } from 'react-router-dom';

export default function SEOContent() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full tracking-wide">
                About GTBuy
              </span>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight">
              What Is <span className="italic text-primary-500">GTBuy Sheet</span>?
            </h2>
            <div className="mt-8 space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong>GTBuy Sheet</strong> is a sophisticated product comparison and discovery platform designed to help shoppers navigate the vast world of fashion and lifestyle products with ease. Whether you are searching for the latest <strong>sneakers</strong>, cozy <strong>hoodies</strong>, or premium <strong>accessories</strong>, GTBuy Sheet organizes everything into an intuitive category-based system that saves you time and money.
              </p>
              <p>
                Unlike traditional shopping websites that overwhelm you with endless scrolling, GTBuy Sheet uses a structured spreadsheet-style approach to present products clearly and efficiently. Each category — from <strong>Shoes</strong> and <strong>T-Shirts</strong> to <strong>Bags</strong> and <strong>Perfumes</strong> — is carefully curated to ensure you find exactly what you are looking for without the clutter.
              </p>
              <p>
                The platform integrates seamlessly with the <strong>kaspreadsheet.com</strong> ecosystem, giving you direct access to thousands of products across 14 specialized categories. With GTBuy Sheet, smart shopping becomes second nature — compare, discover, and buy with confidence.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">14 Product Categories</h4>
                  <p className="text-xs text-foreground-600 mt-1">From Shoes to Perfumes, everything organized for quick access</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-flashlight-line text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">Instant Comparison</h4>
                  <p className="text-xs text-foreground-600 mt-1">Compare products side by side with spreadsheet intelligence</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">Curated Selections</h4>
                  <p className="text-xs text-foreground-600 mt-1">Every product handpicked for quality and value</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-global-line text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">Global Shopping</h4>
                  <p className="text-xs text-foreground-600 mt-1">Shop across markets with seamless category navigation</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 flex flex-col justify-center">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20shopping%20concept%20flat%20lay%20with%20tablet%20displaying%20clean%20product%20comparison%20interface%20surrounded%20by%20stylish%20fashion%20items%20including%20designer%20sneakers%20silk%20scarf%20and%20minimalist%20watch%20on%20warm%20cream%20desk%20soft%20natural%20window%20light%20creating%20gentle%20highlights%20clean%20editorial%20photography%20modern%20productivity%20aesthetic&width=700&height=900&seq=seo-content-v2&orientation=portrait"
                alt="GTBuy Sheet product comparison system"
                className="w-full h-auto object-cover"
              />
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center">
              <Link
                to="/article/gtbuy-spreadsheet-guide"
                className="px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Our Full Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 text-sm font-medium text-foreground-700 border border-foreground-300 rounded-full hover:bg-foreground-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Start Shopping
                <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}